module.exports = __webpack_public_path__ + "img/vz-styling-icons-email.7c64a3f0.svg";